/*
 * @Author: Huangxianlong
 * @Date: 2023-08-10 16:48:30
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2024-05-31 09:30:49
 * @FilePath: \monitor\src\language\user\login.js
 * @Description:
 */
const info = {
  CN: {
    //中文翻译login: "登录",
    welcome: "欢迎使用深圳建泰实时监测平台",
    loginUsername: "请输入用户名",
    iphone: "+86 18558901959",
    // iphone: "+86 18598011635",
    describe1: "传感器实时采集系统平台",
    describe2: "振动实时监测",
    describe3: "结构变形实时监测",
    loginTitle: "用户登录",
    userNamepla: "请输入用户名",
    passwordPla: "请输入密码",
    loginBtn: "登录",
    register: "注册",
    forgetpwd: "忘记密码",
    errorTitle: "登录失败",
    tips: "温馨提示",
    sessionLost: "会话丢失，请重新登录",
    connectionFailed: "服务器连接失败,请稍后重试!",
    passwordFailed: "用户密码不匹配",
    apiFailed: "请求失败",
    getCaptchaSuccess: "发送验证码成功",
    userEmailErr: "用户邮箱不匹配",
    noUserErr: "该用户不存在",
    userEmail: "用户名和邮箱不能为空",
    emailpla: "请输入正常的邮箱",
    getCaptchaFail: "发送验证码失败",
    passwordSuccess: "密码重置成功",
    passwordErr: "密码重置失败",
    codeExpired: "验证码已过期，请重新获取",
    codeMismatch: "验证码不匹配",
    requiredEmpty: "必填信息不能为空",
    captchapla: "请输入验证码",
    captcha: "验证码不能为空",
    captchaErr: "验证码错误，请重试",
  },
  EN: {
    //英文翻译login: "Login",
    welcome: "Welcome to SensingTech Realtime Monitoring Center",
    loginUsername: "Please input username",
    iphone: "+65 69049511",
    describe1: "Real-time Sensors Monitoring",
    describe2: "Real-time Vibration Monitoring",
    describe3: "Real-time Automatic Structural Monitoring",
    loginTitle: "Please login",
    userNamepla: "Please input username",
    passwordPla: "Please input password",
    loginBtn: "Login",
    register: "Register",
    forgetpwd: "Forgot password",
    errorTitle: "Login failed",
    tips: "Tips",
    sessionLost: "Session lost, please login again",
    connectionFailed: "Server connection failed. Please try again later!",
    passwordFailed: "User password mismatch",
    apiFailed: "Request failure",
    getCaptchaSuccess: "Successfully sent verification code",
    userEmailErr: "User email mismatch",
    noUserErr: "The user does not exist",
    userEmail: "User name and email cannot be empty",
    emailpla: "Please enter a normal email address",
    getCaptchaFail: "Sending verification code failed",
    passwordSuccess: "Password reset successful",
    passwordErr: "Password reset failed",
    codeExpired: "The verification code has expired, please obtain it again",
    codeMismatch: "Verification code mismatch",
    requiredEmpty: "Required information cannot be empty",
    captchapla: "Please enter the verification code",
    captcha: "The verification code cannot be empty",
    captchaErr: "Verification code error, please try again"
  }
};
export default info; //需要暴露出去



// WEBPACK FOOTER //
// ./src/language/user/login.js